<!--suppress TypeScriptUnresolvedVariable -->
<div *ngIf="constructor.name.length > 1" class="component-name">>> {{constructor.name}} <<</div>

<div class="wrapper" [class.no-location]="!currentUser.locationId" (click)="loadMenuItems(); menu.toggle($event)">
    <div *ngIf="!deviceManager.isMobile"><i class="fa fa-map-marker-alt"></i></div>
    <div class="location-name-area">
        <div *ngIf="deviceManager.isMobile" class="location-label">Location: </div>
        <div *ngIf="currentUser.locationId != null" class="location-text">{{currentUser.locationName}}</div>
    </div>
</div>

<p-menu #menu [popup]="true" [model]="locationItems">
    <ng-template pTemplate="start" *ngIf="!authManager.currentUser.isGlobalReader">
        <div *ngIf="authManager.currentUser.isUberAdmin" (click)="menu.toggle();addLocationFormVisible = true" style="width: 100%; font-size: 1.1rem; font-weight: bold; cursor: pointer; text-align: center; border-bottom: 1px solid rgba(0,0,0,.2); padding: 4px 0;"><i class="pi pi-plus"></i> Add location</div>
    </ng-template>
</p-menu>

<div class="add-subsidiary-form" *ngIf="addLocationFormVisible" [formGroup]="addLocationForm">
    <div>
        <input type="text" formControlName="name">
        <div>*Name</div>
    </div>
    <div>
        <input type="text" formControlName="address">
        <div>*Address</div>
    </div>
    <div class="group">
        <div>
            <input type="text" formControlName="city">
            <div>*City</div>
        </div>
        <div class="state">
            <input type="text" formControlName="state" maxlength="2">
            <div>*State</div>
        </div>
    </div>
    <div class="group">
        <div>
            <input type="text" formControlName="zip">
            <div>*ZIP</div>
        </div>
        <div class="poNumberPrefix">
            <input type="text" formControlName="poNumberPrefix">
            <div>PO number prefix</div>
        </div>
    </div>
    <div class="group">
        <div>
            <input type="number" formControlName="latitude">
            <div>Latitude</div>
        </div>
        <div>
            <input type="number" formControlName="longitude">
            <div>Longitude</div>
        </div>
    </div>
    <div>
        <p-dropdown [options]="timeZones" placeholder="Select Timezone" formControlName="timeZone"></p-dropdown>
    </div>
    <div class="buttons">
        <p-button (click)="addLocationFormVisible = false; addLocationForm.reset()">Cancel</p-button>
        <p-button [disabled]="!addLocationForm.valid" (click)="addLocationFormVisible = false; addLocation()">Save</p-button>
    </div>
</div>